import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { FinanceInvoiceResourceInput, InvoiceFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { FileWithStatus } from 'modules/finance/components/FileWithStatusDropzone'
import { InvoicesDropzone } from 'modules/finance/components/InvoicesDropzone'

export interface InvoicesUploadModalProps {
  onClose: () => void
  vendorId?: string
  projectId?: string
}

export const InvoicesUploadModal = ({ onClose, vendorId, projectId }: InvoicesUploadModalProps) => {
  const [filesStatus, setFilesStatus] = useState<FileWithStatus<InvoiceFragment>[]>([])

  const resource: FinanceInvoiceResourceInput | undefined = projectId
    ? {
        id: projectId,
        type: 'project',
      }
    : undefined

  const footer = (
    <Button
      submit
      disabled={
        !filesStatus.length || filesStatus.filter((el) => el.status === 'waiting').length > 0
      }
      onClick={() => {
        track(trackingEvents.accounting.invoices.saveUploadInvoice, {
          fromProject: projectId ? true : false,
        })
      }}
    >
      {i18n.t('finance.invoices.upload_invoice_modal.finish_and_close')}
    </Button>
  )

  return (
    <Modal
      illustration="file-upload"
      title={i18n.t('finance.invoices.upload_invoice_modal.title')}
      description={i18n.t('finance.invoices.upload_invoice_modal.description')}
      onClose={onClose}
      onSubmit={onClose}
      footer={footer}
    >
      <InvoicesDropzone
        onUploadFinish={(filesStatusP) => setFilesStatus(filesStatusP)}
        vendorId={vendorId}
        resources={resource && [resource]}
      />
    </Modal>
  )
}
